import React from 'react'
import { isNil } from 'lodash'
import { useTranslation } from 'react-i18next';
// ANTD
import { Col, Row } from 'antd'
import { DetailsContainer } from 'Components/shared/details-container';

const Attachment = ({
    driverDetails,
}) => {
    const { t } = useTranslation();
    const attachmentInfo = [
        {
            label:t("label.nricPassport").toUpperCase(),
            value:driverDetails?.attachments[0]?.file?.fileName || '-',
            link:!isNil(driverDetails?.attachments[0]?.file?.file_url) ? driverDetails?.attachments?.[0]?.file?.file_url : `#`
        },
        {
            label:t("label.drivingLicense"),
            value:driverDetails?.attachments[1]?.file?.fileName || '-',
            link:!isNil(driverDetails?.attachments[1]?.file?.file_url) ? driverDetails?.attachments?.[1]?.file?.file_url : `#`
        },
        {
            label:t("label.roadTax"),
            value:driverDetails?.attachments[2]?.file?.fileName || '-',
            link:!isNil(driverDetails?.attachments[2]?.file?.file_url) ? driverDetails?.attachments?.[2]?.file?.file_url : `#`
        },
        {
            label:t("label.photoOfVehicle"),
            value:driverDetails?.attachments[3]?.file?.fileName || '-',
            link:!isNil(driverDetails?.attachments[3]?.file?.file_url) ? driverDetails?.attachments?.[3]?.file?.file_url : `#`
        },
    ]

    return (
        <>
            <DetailsContainer 
                listOfData={attachmentInfo}
            />
        </>
    )
}

export default Attachment